import { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const cursorRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [hoveredView, setHoveredView] = useState(false);
  const [hoveredCheck, setHoveredCheck] = useState(false);
  const [isDarkBg, setIsDarkBg] = useState(false);
  const [isButtonOrLink, setIsButtonOrLink] = useState(false);

  useEffect(() => {
    let mouseX = 0;
    let mouseY = 0;
    let currentX = 0;
    let currentY = 0;

    const lerp = (start, end, amt) => start + (end - start) * amt;

    const getBrightness = (color) => {
      const [r, g, b] = color.replace(/[^\d,]/g, "").split(",").map(Number);
      return 0.299 * r + 0.587 * g + 0.114 * b;
    };

    const isDarkColor = (color) => {
      if (!color || color === "transparent") return false;
      return getBrightness(color) < 160;
    };

    const moveCursor = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      const el = document.elementFromPoint(mouseX, mouseY);
      if (el) {
        const styles = window.getComputedStyle(el);
        const textColor = styles.color;
        const bgColor = styles.backgroundColor;

        const darkText = isDarkColor(textColor);
        const darkBg = isDarkColor(bgColor);

        setIsDarkBg(!darkText || darkBg);

        const isInteractive = el.tagName === "A" || el.tagName === "BUTTON";
        setIsButtonOrLink(isInteractive);
      }
    };

    const render = () => {
      currentX = lerp(currentX, mouseX, 0.15);
      currentY = lerp(currentY, mouseY, 0.15);

      if (cursorRef.current) {
        cursorRef.current.style.top = `${currentY}px`;
        cursorRef.current.style.left = `${currentX}px`;
      }

      requestAnimationFrame(render);
    };

    const addHoverListeners = () => {
      document.querySelectorAll("[data-cursor='hover']").forEach((el) => {
        el.addEventListener("mouseenter", () => setHovered(true));
        el.addEventListener("mouseleave", () => setHovered(false));
      });

      document.querySelectorAll("[data-cursor='view']").forEach((el) => {
        el.addEventListener("mouseenter", () => setHoveredView(true));
        el.addEventListener("mouseleave", () => setHoveredView(false));
      });

      document.querySelectorAll("[data-cursor='check']").forEach((el) => {
        el.addEventListener("mouseenter", () => setHoveredCheck(true));
        el.addEventListener("mouseleave", () => setHoveredCheck(false));
      });
    };

    addHoverListeners();
    const observer = new MutationObserver(addHoverListeners);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("mousemove", moveCursor);
    requestAnimationFrame(render);

    return () => {
      document.removeEventListener("mousemove", moveCursor);
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={cursorRef}
      className={`pointer-events-none fixed top-0 left-0 z-[9999] 
        flex items-center justify-center 
        transition-all duration-150 ease-out mix-blend-difference
        ${hoveredView ? "rounded-md w-16 h-6" : isButtonOrLink ? "rounded-full w-5 h-5" : "rounded-full w-5 h-5"}
        ${hovered || hoveredView ? "scale-150": hoveredCheck ? "rounded-md lg:w-20 2xl:w-24 h-8": "scale-100"}
      `}
      style={{
        transform: "translate(-50%, -50%)",
        backgroundColor:
          hovered || hoveredView || isButtonOrLink || hoveredCheck
            ? "#f56944"
            : isDarkBg
            ? "#ffffff"
            : "#000000",
        color: isDarkBg ? "#000000" : "#ffffff",
      }}
    >
      {hoveredView && <span className="text-xs font-semibold ">View</span>}
      {hoveredCheck && <span className="text-xs font-semibold ">Check it</span>}
    </div>
  );
}
